import React, { Fragment } from 'react';
import { SortableElement } from 'react-sortable-hoc';

const TableDraggableRow = SortableElement(({ children }) => <Fragment>{children}</Fragment>);

export default TableDraggableRow;
